package br.com.vvrefeicoes.portal.domain.model

data class FoodPassClient(
    val id: String,
    val name: String,
    val document: String,
    val email: String,
    val active: Boolean,
    val balanceCents: Long,
)

data class FoodPassConsumption(
    val id: String,
    val companyId: String,
    val clientId: String,
    val companyServiceId: String,
    val nfcId: String,
    val amountCents: Long,
    val consumedAt: String,
    val clientName: String? = null,
    val serviceName: String? = null,
    val balanceCents: Long? = null,
)

data class FoodPassStatementEntry(
    val type: String,
    val amountCents: Long,
    val direction: String,
    val description: String,
    val referenceId: String?,
    val occurredAt: String,
)

data class FoodPassBilling(
    val companyId: String,
    val from: String,
    val to: String,
    val consumptionCount: Long,
    val totalCents: Long,
)
